import { css } from "@linaria/core";
import { units, breakpoints, typographies } from "@pm2/compat";

export const CAPTION_TRANSITION_DURATION_MS = 225;

export const container = css`
  margin-bottom: ${units.px(3 * 10)};
`;

export const header = css`
  margin-bottom: ${units.px(15)};

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${units.px(5)} ${units.px(20)};

  @media ${breakpoints.mobile.andDown().toQuery()} {
    flex-direction: column-reverse;
    align-items: flex-start;
  }
`;

export const headerText = css`
  max-width: ${units.px(650)};
`;

export const heading = css`
  margin-bottom: ${units.px(6)};

  overflow-wrap: anywhere;

  font-family: ${typographies.heading4()};
  text-wrap: pretty;
`;

export const elementToolbar = css`
  margin-top: ${units.px(-7)};
  place-self: flex-start flex-end;

  @media ${breakpoints.mobile.andDown().toQuery()} {
    margin-top: ${units.px(0)};
    align-self: flex-end;
  }
`;
